export default {
  setUser (context, payload) {
    context.commit('userData', payload)
    context.commit('loginStatus', true)
  },

  setRoomDialog (context, payload) {
    context.commit('setRoomDialogOpen', payload)
  },

  resetUser (context) {
    let settingsRoom = localStorage.getItem('settingsRoom')
    context.commit('userData', null)
    context.commit('loginStatus', undefined)
    localStorage.removeItem('access_token')
    context.commit('setRoomDialogOpen', [])
    localStorage.removeItem('roomDialogOpen')
    localStorage.removeItem('dialog_open')
    localStorage.clear()
    localStorage.setItem('settingsRoom', settingsRoom)
  }
}
